import { render } from "./GameField.vue?vue&type=template&id=17d05d0d"
import script from "./GameField.vue?vue&type=script&lang=js"
export * from "./GameField.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\game\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__